

const initialState = {
    emailSettingDetailsError: {
       emailTitleErr: {},
       fromEmailErr: {},
       fromEmailPasswordErr: {},
       portErr: {},
       hostErr:{},
       bccEmailErr:{}
    }
  };
  
  const emailSettingErrorReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'EMAILSETTINGSDETAILSERROR':
        if (!action.payload) {
          return initialState;
        } else {
          return {
            ...state,
            emailSettingDetailsError: action.payload
          };
        }
      default:
        return state;
    }
  };
  
  export default emailSettingErrorReducer;